<template>
  <div class="md container mx-auto p-8 bg-white rounded-lg rounded-l-none shadow-lg pb-0 md:pb-8 min-div-width">
    <!-- search input field -->
    <div class="w-full flex flex-col items-start">
      <label class="label">
        Search Brokers:
      </label>
      <input class="outline-none border rounded border-grey py-2 px-2" type="text" placeholder="type here..."
             v-model="searchBrokers">
    </div>
    <!-- search input field -->
    <vue-table
      :row-data="showBrokersList"
      :column-heads="columnHeads"
      @rowClick="rowCallback"
      search-criteria="name.props.name"
      :search-value="searchBrokers"
      :tool-tip-content="toolTipContent"
      type="brokerList"
      @sortBy="sortTableBy"
    />
  </div>
</template>

<script>
import StepProgress from '@/components/TableComponents/CompletedSteps.vue';
import Table from '@/components/Table.vue';
import {mapActions, mapGetters, mapMutations, mapState} from 'vuex';
import find from 'lodash/find';
import moment from 'moment';

const columnHeads = ['name', 'stage', 'business name', 'email', 'phone number', 'active applications']

export default {
  name: 'AggregatorBrokerListPage',
  metaInfo: {
    title: 'Brokers | SocietyOne Personal Loans',
  },
  components: {
    'step-progress': StepProgress,
    'vue-table': Table,
  },
  data() {
    return {
      columnHeads,
      searchBrokers: '',
      toolTipContent: {
        content:
          `
          <ul>
            <li>Stage 1 means that you have just submitted the request but the broker has not started the accreditation process.</li>
            <li>Stage 2 means the broker has not completed the training process.</li>
            <li>Stage 3 means the broker is successfully accredited.</li>
          </ul>
        `,
        trigger: 'click',
      },
      sortCriteria: [],
    }
  },
  props: ['brokerId'],
  mounted() {
    this.fetchBrokers();
  },
  computed: {
    ...mapState({
      // getBrokers: ({ brokers }) => brokers.brokers,
      brokerTabs: ({brokers}) => brokers.brokerTabs,
    }),
    ...mapGetters({
      getBrokers: 'brokers/getBrokers',
    }),
    showBrokersList() {
      const appList = this.getBrokers;
      this.sortCriteria.forEach((item) => {
        appList.sort((a, b) => {
          if (item.type === 'stage') {
            return item.asec
              ? a.stage.props['current-step'] - b.stage.props['current-step']
              : b.stage.props['current-step'] - a.stage.props['current-step']
          }
          if (item.type === 'date updated') {
            return item.asec
              ? moment(a.dateUpdated) - moment(b.dateUpdated)
              : moment(b.dateUpdated) - moment(a.dateUpdated)
          }
          if (item.type === 'name') {
            const data = item.asec
              ? a.name.props.name > b.name.props.name
              : b.name.props.name > a.name.props.name
            return data ? 1 : -1
          }
          if (item.type === 'business name') {
            const data = item.asec
              ? a.businessName > b.businessName
              : b.businessName > a.businessName
            return data ? 1 : -1
          }
          if (item.type === 'active applications') {
            return item.asec
              ? a.activeApplications.props.number - b.activeApplications.props.number
              : b.activeApplications.props.number - a.activeApplications.props.number
          }
        })
      })
      return [...appList]
    },
  },
  methods: {
    ...mapActions({
      fetchBrokers: 'brokers/fetchBrokers',
      fetchBrokersApplications: 'brokers/fetchBrokersApplications',
    }),
    ...mapMutations({
      toggleBroker: 'brokers/toggleBroker',
    }),
    sortTableBy(criteria) {
      console.log('hi', criteria)
      this.sortCriteria = criteria
    },
    async rowCallback(rowData) {
      this.toggleBroker({name: rowData.name.props.name, id: rowData.metaData.id})
      // if the broker tab is already existent, don't re navigate but just remove it from the tab list
      if (!find(this.brokerTabs, (item) => item.id === rowData.metaData.id)) {
        return;
      }
      await this.fetchBrokersApplications({id: rowData.metaData.id})
      this.$router.push({name: 'AggregatorBrokerAppList', params: {id: rowData.metaData.id}})
    },
  },
};
</script>

<style scoped>
.min-div-width {
  min-width: 1132px;
}

td {
  min-width: 120px;
  max-width: 290px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Aggregator/AggregatorBrokerList.vue